import { render, staticRenderFns } from "./Released.vue?vue&type=template&id=3c1b5c36&scoped=true&"
var script = {}
import style0 from "./Released.vue?vue&type=style&index=0&id=3c1b5c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b5c36",
  null
  
)

export default component.exports